import { useMutation } from '@tanstack/react-query'
import { axios } from 'Lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'

type Params = {
  currentPassword: string
  newPassword: string
}

const updatePassword = async (params: Params) => {
  const userId = useUserStore.getState().userId
  await axios.put(`users/${userId}/password`, params)
}

export const useUpdateUserPassword = () => {
  const { mutate, isLoading, isError, error } = useMutation(updatePassword)

  return { mutate, isLoading, isError, error }
}
